module.exports = __webpack_public_path__ + "static/media/tutorial-2.dc2a143f.png";